import { useCallback } from "react"
import { NavigateOptions, To, useLocation, useNavigate } from "react-router"

/**
 * A hook that wraps useNavigate to automatically include the current location
 * as the 'backgroundLocation' in the navigation state.
 *
 * This is used to open modals that overlay the current page without unmounting it.
 */
export function useModalNavigate() {
	const navigate = useNavigate()
	const location = useLocation()

	return useCallback(
		(to: To, options?: NavigateOptions) => {
			navigate(to, {
				...options,
				state: {
					...options?.state,
					backgroundLocation: location,
				},
			})
		},
		[location, navigate],
	)
}
